import { Injectable, inject } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';

@Injectable({
    providedIn: 'root',
})
export class RecaptchaService {
    private readonly reCaptchaV3Service = inject(ReCaptchaV3Service);

    public async check(action: string): Promise<string> {
        let gcToken: string = '';
        try {
            gcToken = (await this.reCaptchaV3Service.execute(action).toPromise()) ?? '';
        } catch {
            console.error('hyponamiru: Error executing reCAPTCHA service.');
        }
        return gcToken;
    }
}
